import React, { useEffect } from 'react';
import TextLogo from './TextLogo';

const SplashScreen = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 2000); // 2 saniye sonra kaybolacak

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
      <div className="animate-fadeOut">
        <TextLogo color="secondary" size="responsive" />
      </div>
    </div>
  );
};

export default SplashScreen;
